import React, { useMemo } from 'react';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import List from 'devextreme-react/list';
// import { useAuth } from '../../contexts/auth';
import { useDispatch, useSelector } from "react-redux";
import * as authActions from '../../actions/authActions';
import './user-panel.scss';
import { useHistory } from 'react-router';

export default function ({ menuMode }) {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);


  // const { user, logOut } = useAuth();
  const history = useHistory();

  function userProfile() {
    history.push("profile");
  }

  function logout() {
    dispatch(authActions.logout());
  }
 
  const menuItems = useMemo(() => ([
    {
      text: 'Profile',
      icon: 'user',
      onClick: userProfile
    },
    {
      text: 'Logout',
      icon: 'runner',
      onClick: logout
    }
  ]), [logout]);

  return (
    <div className={'user-panel'}>
      <div className={'user-info'}>
        <div className={'image-container'}>
          <i className={'dx-icon-user'}
             style={{fontSize:24}}
            />
        </div>
        <div className={'user-name'}>{auth.user.name}</div>
      </div>

      {menuMode === 'context' && (
        <ContextMenu
          items={menuItems}
          target={'.user-button'}
          showEvent={'dxclick'}
          width={210}
          cssClass={'user-menu'}
        >
          <Position my={'top center'} at={'bottom center'} />
        </ContextMenu>
      )}
      {menuMode === 'list' && (
        <List className={'dx-toolbar-menu-action'} items={menuItems} />
      )}
    </div>
  );
}
